import { updateProfileAction } from '../update'
import { PROFILE_KEY } from '../../../../../models/profile/constants'
import { PROFILES_ACTION } from '../../constants'

export function updateFitnessLevelProfileAction (value) {
  return updateProfileAction({
    type: PROFILES_ACTION.UPDATE_FITNESS_LEVEL,
    payload: {
      key: PROFILE_KEY.FITNESS_LEVEL,
      value
    }
  })
}
